function equalHeight(group) {
  var tallest = 0;
  group.each(function() {
    var thisHeight = $(this).height();
    if(thisHeight > tallest) {
      tallest = thisHeight;
    }
  });

  $(group).height(tallest);
}

function heightReset(group) {
  $(group).height('auto');
}  

$(document).ready(function(){
	window.addEventListener('DOMContentLoaded', (event) => {
      if (window.innerWidth >= 750){
        equalHeight($(".eq"));
      }
    });
    
    $(window).on('resize', function(){
      if (window.innerWidth >= 750){
        heightReset($(".eq"));
        equalHeight($(".eq"));
      }
      else{
        heightReset($(".eq"));
      }
    });
  
});